import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectUser = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.user;
};
export const selectQualificationCategories = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.qualificationCategories;
};

export const UserTypes = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.usertypes;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer === false) {
        return false;
    } else {
        return _.get(UserProfile_reducer, "profile.profile") || false;
    }
};

export const selectPostSuccess = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.postSuccess;
};
export const selectPostFail = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.postFail;
};
export const selectAllUsers = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.allUsers;
};
export const selectDepartments = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.departments;
};
export const selectAreas = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.areas;
};
export const selectLoggedProfile = ({ RouterReducer = false }) => {
    if (RouterReducer === false) {
        return false;
    } else {
        return _.get(RouterReducer, "profile") || false;
    }
};
export const UserJobpacksData = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.userJobpacks;
};
export const selectNickNames = ({ MainReducer }) => {
    return MainReducer.users;
};

export const selectAllNickNames = createSelector(
    [selectNickNames],
    (nickNames = false) => {
        let nameArray = [];
        if (nickNames) {
            Object.values(nickNames).map((user) => {
                if (
                    typeof user.profile.nick_name === "undefined" ||
                    user.profile.nick_name === null ||
                    user.profile.nick_name === ""
                ) {
                    return null;
                } else {
                    nameArray.push(user.profile.nick_name);
                }
                return null;
            });
            return nameArray;
        } else {
            return [];
        }
    }
);

export const selectPermissions = createSelector(
    [selectConfig, selectLoggedProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["user_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const selectRequesting = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.requesting;
};
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectUserTypes = createSelector([UserTypes], (userTypes) => {
    if (
        userTypes === false ||
        typeof userTypes === "undefined" ||
        userTypes === null
    ) {
        return [];
    }
    let userType = Object.keys(userTypes).map((userType) => {
        return userType;
    });
    return userType;
});

export const selectUsers = createSelector([selectAllUsers], (users = false) => {
    if (users) {
        let userInfo = Object.keys(users).map((e) => {
            let deleted = _.get(users[e], "profile.deleted") || false;
            let fname = _.get(users[e], "profile.first_name") || "N/A";
            let lname = _.get(users[e], "profile.last_name") || "N/A";
            if (!deleted) {
                return { uid: e, fname, lname };
            } else {
                return null;
            }
        });
        return _.orderBy(_.compact(userInfo), ["fname", "lname"]);
    } else {
        return false;
    }
});
export const selectName = createSelector([selectProfile], (profile = false) => {
    if (profile === false) {
        return "";
    } else {
        return profile.first_name + " " + profile.last_name;
    }
});
export const selectUserProfile = createSelector(
    [selectUser],
    (user = false) => {
        if (user) {
            return _.get(user, "profile");
        } else {
            return false;
        }
    }
);
export const selectQualificationsPerCategory = createSelector(
    [selectUser, selectQualificationCategories],
    (user = false, categories = false) => {
        if (user && categories) {
            const qualificationsPerUser =
                _.get(user, "profile.qualifications_per_user") || false;

            if (qualificationsPerUser) {
                let qualificationsByCategory = Object.keys(categories).map(
                    (category_key) => {
                        let qualificationInfoPerCategory = getQualInfoPerCategory(
                            categories[category_key],
                            qualificationsPerUser
                        );
                        if (
                            qualificationInfoPerCategory.qualsInCategory
                                .length !== 0
                        ) {
                            return qualificationInfoPerCategory;
                        } else {
                            return null;
                        }
                    }
                );
                return _.compact(qualificationsByCategory);
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
);
const getQualInfoPerCategory = (category, qualifications) => {
    let completed = 0;
    let currentDate = moment();

    let qualificationsInCategory = Object.keys(qualifications).map(
        (qualification_key) => {
            let expDate = moment(
                qualifications[qualification_key].qualification_exp_date,
                "DD/MM/YYYY"
            );
            let inDate = expDate.isAfter(currentDate) === true ? true : false;
            let verified =
                qualifications[qualification_key].qualification_verified ===
                "No"
                    ? false
                    : true;

            let validQualifiation = inDate && verified ? true : false;

            if (
                qualifications[qualification_key].qualification_category ===
                category
            ) {
                if (validQualifiation) {
                    completed++;
                }
                return {
                    ...qualifications[qualification_key],
                    valid: validQualifiation,
                };
            }
            return null;
        }
    );
    return {
        category,
        completed,
        qualsInCategory: _.compact(qualificationsInCategory),
    };
};

export const selectAllUsersDetails = createSelector(
    [selectAllUsers],
    (users = false) => {
        if (users) {
            let userInfo = Object.keys(users).map((e) => {
                return _.get(users[e], "profile");
            });
            return userInfo;
        } else {
            return false;
        }
    }
);
export const selectUserMapsData = createSelector(
    [UserJobpacksData, selectUser, selectAllUsers],

    (jobpacks = false, user = false, users = false) => {
        let mapData = [];
        let map1 = [];
        //open & closed inspection calculation
        let assigned_items = _.get(user, "assigned_items");
        let open_count = 0;
        let close_count = 0;
        if (assigned_items) {
            assigned_items = Object.values(assigned_items);
            assigned_items.map((g) => {
                if (g.closed_timestamp === "undefined") {
                    open_count = open_count + 1;
                } else {
                    close_count = close_count + 1;
                }
                return false;
            });
        }
        //report count calculation
        let map2 = [];
        let profile = _.get(user, "profile");
        let userData = [];
        let reportCount = 0;
        if (profile && users[profile.uid]) {
            userData = users[profile.uid].report_count;
            for (var x in userData) {
                reportCount += userData[x];
            }
        }
        //jobpack count calculation
        if (jobpacks) {
            let jobPackCreatedCount = 0;
            for (var i in jobpacks) {
                //months
                let data = jobpacks[i];
                for (var j in data) {
                    //users
                    let data2 = data[j];
                    for (var k in data2) {
                        //actual data
                        if (
                            data2[k].profile.created_by &&
                            data2[k].profile.created_by.user_uid === profile.uid
                        ) {
                            jobPackCreatedCount = jobPackCreatedCount + 1;
                        }
                    }
                }
            }

            //user analytics
            map1 = {
                labels: [
                    "Reports Count - " + reportCount,
                    "Jobpack Count - " + jobPackCreatedCount,
                ],
                datasets: [
                    {
                        data: [reportCount, jobPackCreatedCount],
                        backgroundColor: ["#FF6384", "#36A2EB"],
                        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
                    },
                ],
            };
            map2 = {
                labels: [
                    "Open Item - " + open_count,
                    "Closed Item - " + close_count,
                ],
                datasets: [
                    {
                        data: [open_count, close_count],
                        backgroundColor: ["#FF6384", "#36A2EB"],
                        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
                    },
                ],
            };
            mapData = { map1: map1, map2: map2 };
            return mapData;
        } else {
            return false;
        }
    }
);
